(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/mini/assets/javascripts/views/playnow.js') >= 0) return;  svs.modules.push('/components/statistics/mini/assets/javascripts/views/playnow.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.components = svs.components || {};
  svs.components.views = svs.components.views || {};

  svs.components.views.PlayNow = Backbone.View.extend({
    events: {
      'click .mini-play-now': 'playNow'
    },

    initialize: function(model) {
      this.modelReference = model;
    },

    render: function() {
      if (this.modelReference) {
        this.$el.html(
          svs.statistics.mini.templates.playnowbutton(
            this.modelReference.toJSON()
          )
        );
      }
      return this;
    },

    onDestroy: function() {
      this.undelegateEvents();
      this.remove();
      Backbone.View.prototype.remove.call(this);
    },

    playNow: function() {
      var self = this;
      svs.core.module.load(
        '/cl/sport/oddset-play',
        null,
        function() {
          svs.sport.oddsetplay.showPlayNow(
            self.modelReference.get('oddsetDraws').drawNumber
          );
        },
        false
      );

      return false;
    }
  });
})(Backbone, _, svs);

 })(window);